<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card
        :title="title"
        color="primary"
      >
        <slot />
      </base-info-card>

      <base-avatar-card
        :icon="address.icon"
        :outlined="false"
        :title="address.title"
        color="transparent"
        horizontal
        space="0"
      >
        <div v-text="address.text1" />
        <div v-text="address.text2" />
      </base-avatar-card>

      <v-divider class="my-2" />

      <base-avatar-card
        :icon="phone.icon"
        :outlined="false"
        :title="phone.title"
        color="transparent"
        horizontal
        space="0"
      >
        <div v-text="phone.text" />
      </base-avatar-card>

      <v-divider class="my-2" />

      <base-avatar-card
        :icon="email.icon"
        :outlined="false"
        :title="email.title"
        color="transparent"
        horizontal
        space="0"
      >
        <div v-text="email.text" />
      </base-avatar-card>
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseBusinessContact',

    props: {
      dark: Boolean,
      dense: Boolean,
      title: String,
    },

    computed: {
      address () {
        return {
          icon: 'mdi-map-marker-outline',
          title: this.$t('PROVIDER_INFO_SECTION_ADDRESS_TEXT'),
          text1: this.$t('PROVIDER_ADDRESS_LINE_1'),
          text2: this.$t('PROVIDER_ADDRESS_LINE_2'),
        }
      },
      phone () {
        return {
          icon: 'mdi-cellphone',
          title: this.$t('PROVIDER_INFO_SECTION_PHONE_TEXT'),
          text: this.$t('PROVIDER_CONTACT_PHONE'),
        }
      },
      email () {
        return {
          icon: 'mdi-email',
          title: this.$t('PROVIDER_INFO_SECTION_EMAIL_TEXT'),
          text: this.$t('PROVIDER_CONTACT_EMAIL'),
        }
      },
    },
  }
</script>
